import React, { Component } from "react";
import '../css/table-responsive.css'
import { AuthContext } from "../services/auth/authContext";
import { getValueCookie } from "../services/cookieService";
import TableSalesTypeView from "../components/TableofSalesType/TableSalesTypeView";
import { getCurrentBalance, getCustomerExcess, getCustomerHistory, getSalesByCustomer, getSalesOrdersPerUser, getSalesPerMonth, getSalesPerRoute, getSalesPerSalesPerson, getShorts } from "./InitialDashBoard/Functions";
import TableofPendingSalesView from "../components/TableofPendingSales/TableofPendingSalesView";
import TableofExcessCustomerView from "../components/TableofExcessCustomer/TableofExcessCustomerView";
import TableofCurrentBalanceView from "../components/TableofCurrentBalance/TableofCurrentBalanceView";
import { MonthInLetters, NameSalesPerson, NumberFormat } from "../functions/generalFunctions";
import CalendarOfSales from "../components/CalendarOfSales/CalendarOfSales";
import TableHistoryCustomerView from "../components/TableHistoryCustomer/TableHistoryCustomerView";
import TableDetailSalesPerRouteView from "../components/TableDetailSalesPerRoute/TableDetailSalesPerRouteView";
import TableShortView from "../components/TableShort/TableShortView";
import { getIndexElement } from "../functions/searchInObject";
import LoadingWindow from "../components/LoadingWindow";
import TableSalesPerSalesPersonView from "../components/TableofSalesPerSalesPerson/TableSalesPerSalesPersonView";
import BarSalesDasboard from "../components/BarSalesDashboard/BarSalesDasboard";
import { getInformationWithData } from '../services/CABE.js'
// Menu
import { Menu } from "../components/Menu/Menu";

export default class SalesLobbyV2 extends Component {
  static contextType = AuthContext;

  constructor(props) {
    super(props);
    this.ModalLoading = React.createRef();
  }

  state = {
    data: []
  }

  componentDidMount() {
    this.getMultipleInfo();
  }

  getInfo(SalesPerson) {
    let button = document.getElementById('LobbyInfoCharge' + SalesPerson)
    if (button) {
      button.click();
    }
  }

  // Get and set sales persons data V2
  async getMultipleInfo() {
    var data = [];
    var now = new Date();
    // Loating modal
    this.ModalLoading.current.showState(true);
    // Get sales persons from cookie
    // const salesPersonList = getValueCookie("SalesPersonList");    V1
    const company = getValueCookie("CompanyId");

    // V2
    const salesPeople = await getInformationWithData('/v2/company/dashboardSalesperson', {companyId: company});
    const salesPersonList = Array.from(
        new Set(
            salesPeople.data
            .map(function (u) { return u.salesPerson; })
            .filter(function (sp) { return sp != null && sp !== ""; })
        )
    );

    console.log("SALES DASHBOARD");
    console.log(salesPersonList);

    for (var i = 0; i < salesPersonList.length; i++) {
      var SalesPerson = salesPersonList[i];

      var temporal = {
        Load: i !== 0, // el primero cargado, el resto marcados como "Load: true" como antes

        SalesPerRouteDate: now,
        SalesPerSalesPersonDate: now,

        SalesPerRoute: { Information: [], Months: [] },
        SalesPerSalesPersons: { Information: [], Months: [] },
        CustomerHistory: [],
        PendingSalesOrders: [],
        CustomerExcess: [],
        CurrentBalance: [],
        SalesPerson: SalesPerson,
        SalesByCustomer: [],
        SalesPerMonth: [],
        RouteYearSales: [],
        Shorts: {},

        Totals: {
          TotalPendingInvoices: {
            TotalDueInv: 0,
            Range1: 0,
            Range2: 0,
            Range3: 0,
            TotalR1: 0,
            TotalR2: 0,
            TotalR3: 0
          },
          SalesOrder: {
            NotStarted: 0,
            InProcess: 0,
            Finished: 0
          },
          Customer: {
            Normal: 0,
            Frequent: 0,
            Waring: 0,
            Risk: 0,
            Total: 0
          },
          Sales: {
            NoInvoices: 0,
            Total: 0
          }
        }
      };

      data.push(temporal);
    }

    // Seteamos el estado una sola vez y luego disparamos la carga del primero
    this.setState({ data: data }, function () {
      // Hide loading
      this.ModalLoading.current.showState(false);

      // Load data individualy
      if (salesPersonList && salesPersonList.length > 0) {
        var first = salesPersonList[0];
        this.getSpecificInfo(true, first); // Aquí entra el orquestador
      }
    }.bind(this));
  }

  // New load center V2
  async getSpecificInfo(flag, SalesPerson) {
    if (!flag) return;

    const index = getIndexElement(this.state.data, 'SalesPerson', SalesPerson);
    if (index === -1) return;

    // Marcar todas las secciones de ese SalesPerson como cargando
    var data = this.state.data.slice();
    var current = data[index];

    data[index] = {
      ...current,
      SalesPerRouteLoading: true,
      SalesPerRouteError: null,
      PendingSalesOrderLoading: true,
      PendingSalesOrderError: null,
      CustomerExcessLoading: true,
      CustomerExcessError: null,
      CurrentBalanceLoading: true,
      CurrentBalanceError: null,
      CustomerHistoryLoading: true,
      CustomerHistoryError: null,
      SalesByCustomerLoading: true,
      SalesByCustomerError: null,
      SalesPerMonthLoading: true,
      SalesPerMonthError: null,
      SalesPerSalesPersonsLoading: true,
      SalesPerSalesPersonsError: null,
      ShortsLoading: true,
      ShortsError: null
    };
    this.setState({ data });

    // Disparar cargas en paralelo (Sin await para hacer carga individual)
    this.loadSalesPerRoute(SalesPerson, index);
    this.loadPendingSalesOrder(SalesPerson, index);
    this.loadCustomerExcess(SalesPerson, index);
    this.loadCurrentBalance(SalesPerson, index);
    this.loadCustomerHistory(SalesPerson, index);
    this.loadSalesByCustomer(SalesPerson, index);
    this.loadSalesPerMonth(SalesPerson, index);
    this.loadSalesPerSalesPersons(SalesPerson, index);
    this.loadShorts(SalesPerson, index);
  }

  // Load sales per route individualy V2
  async loadSalesPerRoute(SalesPerson, index) {
    try {
      const SalesPerRoute = await getSalesPerRoute(SalesPerson);

      var data = this.state.data.slice();
      var current = data[index];

      data[index] = {
        ...current,
        SalesPerRoute: SalesPerRoute,
        SalesPerRouteDate: new Date(),
        SalesPerRouteLoading: false,
        SalesPerRouteError: null
      };

      this.setState({ data: data });
    } catch (e) {
      var dataError = this.state.data.slice();
      var currentError = dataError[index];

      dataError[index] = {
        ...currentError,
        SalesPerRouteLoading: false,
        SalesPerRouteError: 'Can not get data from the API. '
      };

      this.setState({ data: dataError });
    }
  }


  // Loading pending sales individualy V2
  async loadPendingSalesOrder(SalesPerson, index) {
    // Set date
    var dataStart = this.state.data.slice();
    var currentStart = dataStart[index];

    dataStart[index] = {
      ...currentStart
    };
    this.setState({ data: dataStart });

    try {
      const PendingSalesOrder = await getSalesOrdersPerUser(SalesPerson);

      var NotStarted = 0;
      var InProcess = 0;
      var Finished = 0;

      for (var i = 0; i < PendingSalesOrder.length; i++) {
        var SalesOrder = PendingSalesOrder[i];

        SalesOrder.Status = SalesOrder.Status ? SalesOrder.Status : 0;

        switch (SalesOrder.Status) {
          case 0:
            NotStarted += SalesOrder.NonTaxableAmt;
            break;
          case 1:
            InProcess += SalesOrder.NonTaxableAmt;
            break;
          case 2:
            Finished += SalesOrder.NonTaxableAmt;
            break;
          default:
            break;
        }
      }

      var data = this.state.data.slice();
      var current = data[index];

      var currentTotals = current.Totals || {
        TotalPendingInvoices: {
          TotalDueInv: 0,
          Range1: 0,
          Range2: 0,
          Range3: 0,
          TotalR1: 0,
          TotalR2: 0,
          TotalR3: 0
        },
        SalesOrder: {
          NotStarted: 0,
          InProcess: 0,
          Finished: 0
        },
        Customer: {
          Normal: 0,
          Frequent: 0,
          Waring: 0,
          Risk: 0,
          Total: 0
        },
        Sales: {
          NoInvoices: 0,
          Total: 0
        }
      };

      var newTotals = {
        ...currentTotals,
        SalesOrder: {
          NotStarted: NotStarted,
          InProcess: InProcess,
          Finished: Finished
        }
      };

      data[index] = {
        ...current,
        PendingSalesOrders: PendingSalesOrder,
        PendingSalesOrderLoading: false,
        PendingSalesOrderError: null,
        Totals: newTotals
      };

      this.setState({ data: data });
    } catch (e) {
      var dataError = this.state.data.slice();
      var currentError = dataError[index];

      dataError[index] = {
        ...currentError,
        PendingSalesOrderLoading: false,
        PendingSalesOrderError: 'Can not get data from the API. '
      };

      this.setState({ data: dataError });
    }
  }

  // Loading customer excess individualy V2
  async loadCustomerExcess(SalesPerson, index) {
    try {
      const CustomerExcess = await getCustomerExcess(SalesPerson);

      var data = this.state.data.slice();
      var current = data[index];

      data[index] = {
        ...current,
        CustomerExcess: CustomerExcess,
        CustomerExcessLoading: false,
        CustomerExcessError: null
      };

      this.setState({ data: data });
    } catch (e) {
      var dataError = this.state.data.slice();
      var currentError = dataError[index];

      dataError[index] = {
        ...currentError,
        CustomerExcessLoading: false,
        CustomerExcessError: 'Can not get data from the API. '
      };

      this.setState({ data: dataError });
    }
  }

  // Loading customer history individualy V2
  async loadCustomerHistory(SalesPerson, index) {
    try {
      const CustomerHistory = await getCustomerHistory(SalesPerson);

      var data = this.state.data.slice();
      var current = data[index];

      data[index] = {
        ...current,
        CustomerHistory: CustomerHistory,
        CustomerHistoryLoading: false,
        CustomerHistoryError: null
      };

      this.setState({ data: data });
    } catch (e) {
      var dataError = this.state.data.slice();
      var currentError = dataError[index];

      dataError[index] = {
        ...currentError,
        CustomerHistoryLoading: false,
        CustomerHistoryError: 'Can not get data from the API. '
      };

      this.setState({ data: dataError });
    }
  }

  // Loading sales by customer individualy V2
  async loadSalesByCustomer(SalesPerson, index) {
    try {
      const SalesByCustomer = await getSalesByCustomer(SalesPerson, null);

      var data = this.state.data.slice();
      var current = data[index];

      data[index] = {
        ...current,
        SalesByCustomer: SalesByCustomer,
        SalesByCustomerLoading: false,
        SalesByCustomerError: null
      };

      this.setState({ data: data });
    } catch (e) {
      var dataError = this.state.data.slice();
      var currentError = dataError[index];

      dataError[index] = {
        ...currentError,
        SalesByCustomerLoading: false,
        SalesByCustomerError: 'Can not get data from the API. '
      };

      this.setState({ data: dataError });
    }
  }

  // Load sales by month
  async loadSalesPerMonth(SalesPerson, index) {
    try {
      // Totals
      let TotSales = {
        NoInvoices: 0,
        Total: 0
      };

      const SalesPerMonth = await getSalesPerMonth(SalesPerson, null);

      var data = this.state.data.slice();
      var current = data[index];
      // Get totals
      for (const Sale of SalesPerMonth) {
        if (Sale.Week) {
          TotSales.NoInvoices += Number(Sale.totalsales)
          TotSales.Total += Number(Sale.total)
        }
      }

      data[index] = {
        ...current,
        SalesPerMonth: SalesPerMonth,
        SalesPerMonthLoading: false,
        SalesPerMonthError: null,
        NoInvoices: TotSales.NoInvoices,
        Total: TotSales.Total
      };

      this.setState({ data: data });
      // Update calendar
      this.asignTotalsCalendar(SalesPerMonth, SalesPerson);
    } catch (e) {
      var dataError = this.state.data.slice();
      var currentError = dataError[index];

      dataError[index] = {
        ...currentError,
        SalesPerMonthLoading: false,
        SalesPerMonthError: 'Can not get data from the API. '
      };

      this.setState({ data: dataError });
    }
  }


  // Loading sales by sales person V2
  async loadSalesPerSalesPersons(SalesPerson, index) {
    try {
      const SalesPerSalesPersons = await getSalesPerSalesPerson(SalesPerson, null);

      var data = this.state.data.slice();
      var current = data[index];

      data[index] = {
        ...current,
        SalesPerSalesPersons: SalesPerSalesPersons,
        SalesPerSalesPersonsLoading: false,
        SalesPerSalesPersonsError: null
      };

      this.setState({ data: data });
    } catch (e) {
      var dataError = this.state.data.slice();
      var currentError = dataError[index];

      dataError[index] = {
        ...currentError,
        SalesPerSalesPersonsLoading: false,
        SalesPerSalesPersonsError: 'Can not get data from the API. '
      };

      this.setState({ data: dataError });
    }
  }


  // Loading shorts V2
  async loadShorts(SalesPerson, index) {
    try {
      const Shorts = await getShorts(SalesPerson, null);

      var data = this.state.data.slice();
      var current = data[index];

      data[index] = {
        ...current,
        Shorts: Shorts,
        ShortsLoading: false,
        ShortsError: null
      };

      this.setState({ data: data });
    } catch (e) {
      var dataError = this.state.data.slice();
      var currentError = dataError[index];

      dataError[index] = {
        ...currentError,
        ShortsLoading: false,
        ShortsError: 'Can not get data from the API. '
      };

      this.setState({ data: dataError });
    }
  }


  // Loading balance individualy V2
  async loadCurrentBalance(SalesPerson, index) {
    try {
      const CurrentBalance = await getCurrentBalance(SalesPerson);

      var TotalPendingInvoices = {
        TotalDueInv: 0,
        Range1: 0,
        Range2: 0,
        Range3: 0,
        TotalR1: 0,
        TotalR2: 0,
        TotalR3: 0
      };

      for (var i = 0; i < CurrentBalance.length; i++) {
        var Invoice = CurrentBalance[i];
        var balance = Invoice.Balance || 0;
        var days = Number(Invoice.DaysDlq);

        if (balance > 0) {
          TotalPendingInvoices.TotalDueInv += balance;
        }

        if (days <= 14) {
          TotalPendingInvoices.Range1 += 1;
          if (balance > 0) {
            TotalPendingInvoices.TotalR1 += balance;
          }
        } else if (days >= 15 && days <= 29) {
          TotalPendingInvoices.Range2 += 1;
          if (balance > 0) {
            TotalPendingInvoices.TotalR2 += balance;
          }
        } else {
          TotalPendingInvoices.Range3 += 1;
          if (balance > 0) {
            TotalPendingInvoices.TotalR3 += balance;
          }
        }
      }

      var data = this.state.data.slice();
      var current = data[index];

      var currentTotals = current.Totals || {
        TotalPendingInvoices: {
          TotalDueInv: 0,
          Range1: 0,
          Range2: 0,
          Range3: 0,
          TotalR1: 0,
          TotalR2: 0,
          TotalR3: 0
        },
        SalesOrder: {
          NotStarted: 0,
          InProcess: 0,
          Finished: 0
        },
        Customer: {
          Normal: 0,
          Frequent: 0,
          Waring: 0,
          Risk: 0,
          Total: 0
        },
        Sales: {
          NoInvoices: 0,
          Total: 0
        }
      };

      var newTotals = {
        ...currentTotals,
        TotalPendingInvoices: TotalPendingInvoices
      };

      data[index] = {
        ...current,
        CurrentBalance: CurrentBalance,
        CurrentBalanceLoading: false,
        CurrentBalanceError: null,
        Totals: newTotals
      };

      this.setState({ data: data });
    } catch (e) {
      var dataError = this.state.data.slice();
      var currentError = dataError[index];

      dataError[index] = {
        ...currentError,
        CurrentBalanceLoading: false,
        CurrentBalanceError: 'Can not get data from the API. '
      };

      this.setState({ data: dataError });
    }
  }


  async changeMonthSalesPerRoute(SalesPerson, DateC) {
    this.ModalLoading.current.showState(true);
    const temporal = this.state.data
    const index = await getIndexElement(this.state.data, 'SalesPerson', SalesPerson)
    const SalesPerRoute = await getSalesPerRoute(SalesPerson, new Date(DateC))
    const SalesByCustomer = await getSalesByCustomer(SalesPerson, new Date(DateC))
    if (index !== -1) {
      temporal[index].SalesPerRouteMonth = DateC
      temporal[index].SalesPerRoute = SalesPerRoute
      temporal[index].SalesByCustomer = SalesByCustomer
      this.setState({ data: temporal })
    }
    this.ModalLoading.current.showState(false);


  }
  async changeMonthSalesPerSalesPerson(SalesPerson, DateC) {
    this.ModalLoading.current.showState(true);
    const temporal = this.state.data
    const index = await getIndexElement(this.state.data, 'SalesPerson', SalesPerson)
    const SalesPerSalesPersons = await getSalesPerSalesPerson(SalesPerson, new Date(DateC))

    if (index !== -1) {
      temporal[index].SalesPerRouteMonth = DateC
      temporal[index].SalesPerSalesPersons = SalesPerSalesPersons

      this.setState({ data: temporal })
    }
    this.ModalLoading.current.showState(false);


  }

  async changeDateSalesPerMonth(SalesPerson, DateC) {
    this.ModalLoading.current.showState(true);

    const temporal = this.state.data
    let TotSales = {
      NoInvoices: 0,
      Total: 0
    }
    const index = await getIndexElement(this.state.data, 'SalesPerson', SalesPerson)
    const SalesPerMonth = await getSalesPerMonth(SalesPerson, new Date(DateC))
    if (index !== -1) {
      temporal[index].SalesPerRouteDate = new Date(DateC)
      temporal[index].SalesPerMonth = SalesPerMonth
      for (const Sale of SalesPerMonth) {
        if (Sale.Week) {
          TotSales.NoInvoices += Number(Sale.totalsales)
          TotSales.Total += Number(Sale.total)
        }
      }
      temporal[index].Totals.Sales = TotSales
      await this.setState({ data: temporal })
      await this.asignTotalsCalendar(SalesPerMonth, SalesPerson)
    }
    this.ModalLoading.current.showState(false);

  }

  async changeAllMonthData(SalesPerson, DateC) {
    await this.changeMonthSalesPerRoute(SalesPerson, DateC)
    await this.changeDateSalesPerMonth(SalesPerson, DateC)
    if (SalesPerson === 'TOT') {
      await this.changeMonthSalesPerSalesPerson(SalesPerson, DateC)
    }
  }


  asignTotalsCalendar(Data, SalesPerson) {
    for (const week of Data) {

      if (week.Week) {

        let m = document.getElementById('quant_' + week.Week + "_" + SalesPerson)
        let n = document.getElementById('sales_' + week.Week + "_" + SalesPerson)
        if (m) {
          m.innerHTML = NumberFormat(Number(Number(week.totalsales).toFixed(0)))
        }
        if (n) {
          n.innerHTML = "$" + NumberFormat(Number(Number(week.total).toFixed(0)))

        }
      }
    }
  }


  render() {
    return (
      <div>
        <div id="GeneralPages" className="page container-fluid" style={{paddingTop: '50px'}}>
          {/* Main menu */}
          <Menu Refresh={this.state.Refresh} Father={this} />

          {/* Loading modal */}
          <LoadingWindow ref={this.ModalLoading} />

          <div className='col-sm-12'>
            <ul className="nav nav-tabs" id="ScanningControls" role="tablist">
              {this.state.data.map((element, e) => (
                <li key={e} hidden={false} className="nav-item" role="presentation">
                  <button
                    onClick={() => this.getSpecificInfo(element.Load, element.SalesPerson)}
                    id={'DashBoardFromSP' + element.SalesPerson}
                    className={e === 0 ? "nav-link active" : "nav-link"}
                    data-bs-toggle="tab"
                    data-bs-target={"#DashSP" + element.SalesPerson}
                    type="button"
                    role="tab"
                    aria-controls="DashBoardSP"
                    aria-selected="true"
                    style={{ color: e === 0 ? '#0f2342' : '#4c4c4cff' }}
                  >
                    {NameSalesPerson(element.SalesPerson)}
                  </button>
                </li>
              ))}
            </ul>

            <div className="tab-content" id="allDashActive">
              {this.state.data.map((element, e) => (
                <div key={e} className={e === 0 ? "tab-pane fade show active" : "tab-pane fade show"} id={"DashSP" + element.SalesPerson} role="tabpanel" aria-labelledby="">
                  <div className="row pb-4 justify-content-between backgroundGrayLow" style={{ paddingTop: '20px' }}>
                    {
                      element.SalesPerson === 'TOT' ?
                        <React.Fragment>
                          <div className="col-sm-6">
                            <div className="col-12 pt-2 pb-3">
                              <TableSalesTypeView
                                SalesPerson={element.SalesPerson}
                                Father={this}
                                Date={element.SalesPerRouteDate}
                                Month={MonthInLetters(element.SalesPerRouteDate.getMonth() + 1) + " " + element.SalesPerRouteDate.getFullYear()}
                                Title={"Sales by Distribution Channel"}
                                data={element.SalesPerRoute}
                                loading={element.SalesPerRouteLoading}
                                error={element.SalesPerRouteError}
                                key='SalesbyDistributionChannel' 
                                showMonths
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div hidden={element.SalesPerson !== "TOT"} className="col-12 pt-2 pb-3">
                              <TableSalesPerSalesPersonView SalesPerson={element.SalesPerson} Father={this} Date={element.SalesPerRouteDate} Month={MonthInLetters(element.SalesPerRouteDate.getMonth() + 1) + " " + element.SalesPerRouteDate.getFullYear()} Title={"Sales by Sales Person"} data={element.SalesPerSalesPersons} />
                            </div>
                          </div>
                          <div className="col-12">
                            <BarSalesDasboard Title="Graphs of Sales" Data={element.RouteYearSales} />
                          </div>
                          <div className="col-sm-6">

                            <div className="col-12 pt-2 pb-3">
                              <TableDetailSalesPerRouteView Title={"Sales by Customer"} data={element.SalesByCustomer} />
                            </div>
                            <div className="col-12 pt-2 pb-3">
                              <CalendarOfSales Father={this} Totals={element.Totals.Sales} Date={element.SalesPerRouteDate} SalesPerson={element.SalesPerson} data={element.SalesPerMonth} Title={"Sales Per Day"} />
                            </div>
                            {element.SalesPerson !== "TOT" ?
                              <div className="col-12 pt-2 pb-3">
                                <TableShortView SalesPerson={element.SalesPerson} data={element.Shorts} Title={"Shorts of Last 15 Days"} />
                              </div>
                              :
                              <></>}
                          </div>

                          <div className="col-sm-6">
                            <div className="row">

                              <div className="col-sm-12">

                                <div className="row">
                                  <div className="col-12 pt-2 pb-3">
                                    <TableofCurrentBalanceView
                                      Title={"Past Due Invoices"}
                                      Totals={element.Totals.TotalPendingInvoices}
                                      data={element.CurrentBalance}
                                      loading={element.CurrentBalanceLoading}
                                      error={element.CurrentBalanceError}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="col-sm-12">

                                <div className="row">
                                  <div className="col-12 pt-2 pb-3">
                                    <TableofExcessCustomerView
                                      Title={"Customers with Exceeded Credit Limit"}
                                      data={element.CustomerExcess}
                                      loading={element.CustomerExcessLoading}
                                      error={element.CustomerExcessError}
                                    />
                                  </div>
                                </div>


                              </div>
                              {element.SalesPerson !== "TOT" ?
                                <div className="col-sm-12">

                                  <div className="row">
                                    <div className="col-12 pt-2 pb-3">
                                      <TableofPendingSalesView
                                        Title={"Actual Sales Order"}
                                        Totals={element.Totals.SalesOrder}
                                        data={element.PendingSalesOrders}
                                        loading={element.PendingSalesOrderLoading}
                                        error={element.PendingSalesOrderError}
                                      />
                                    </div>
                                  </div>
                                </div>
                                : <></>}

                              <div className="col-sm-12">

                                <div className="row">
                                  <div className="col-12 pt-2 pb-3">
                                    <TableHistoryCustomerView 
                                      Title={"Days of Last Sale"} 
                                      Totals={element.Totals.Customer} 
                                      data={element.CustomerHistory} 
                                    />
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                          <div className="col-sm-6">
                            <div className="col-12 pt-2 pb-3">
                              <TableSalesTypeView
                                SalesPerson={element.SalesPerson}
                                Father={this} Date={element.SalesPerRouteDate}
                                Month={MonthInLetters(element.SalesPerRouteDate.getMonth() + 1) + " " + element.SalesPerRouteDate.getFullYear()}
                                Title={"Sales by Distribution Channel"}
                                data={element.SalesPerRoute}
                                loading={element.SalesPerRouteLoading}
                                error={element.SalesPerRouteError}
                                key='SalesbyDistributionChannel' 
                                showMonths 
                              />
                            </div>
                            <div className="col-12 pt-2 pb-3">
                              <TableDetailSalesPerRouteView Title={"Sales by Customer"} data={element.SalesByCustomer} />
                            </div>
                            <div className="col-12 pt-2 pb-3">
                              <CalendarOfSales 
                                Father={this} 
                                Totals={element.Totals.Sales} 
                                Date={element.SalesPerRouteDate} 
                                SalesPerson={element.SalesPerson} 
                                data={element.SalesPerMonth} 
                                Title={"Sales Per Day"} 
                              />
                            </div>
                            {element.SalesPerson !== "TOT" ?
                              <div className="col-12 pt-2 pb-3">
                                <TableShortView SalesPerson={element.SalesPerson} data={element.Shorts} Title={"Shorts of Last 15 Days"} />
                              </div>
                              :
                              <></>}

                          </div>
                          <div className="col-sm-6">
                            <div className="row">
                              <div hidden={element.SalesPerson !== "TOT"} className="col-12 pt-2 pb-3">
                                <TableSalesPerSalesPersonView SalesPerson={element.SalesPerson} Father={this} Date={element.SalesPerRouteDate} Month={MonthInLetters(element.SalesPerRouteDate.getMonth() + 1) + " " + element.SalesPerRouteDate.getFullYear()} Title={"Sales by Sales Person"} data={element.SalesPerSalesPersons} />
                              </div>

                              <div className="col-sm-12">
                                <div className="row">
                                  <div className="col-12 pt-2 pb-3">
                                    <TableofCurrentBalanceView
                                      Title={"Past Due Invoices"}
                                      Totals={element.Totals.TotalPendingInvoices}
                                      data={element.CurrentBalance}
                                      loading={element.CurrentBalanceLoading}
                                      error={element.CurrentBalanceError}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="col-sm-12">
                                <div className="row">
                                  <div className="col-12 pt-2 pb-3">
                                    <TableofExcessCustomerView
                                      Title={"Customers with Exceeded Credit Limit"}
                                      data={element.CustomerExcess}
                                      loading={element.CustomerExcessLoading}
                                      error={element.CustomerExcessError}
                                    />
                                  </div>
                                </div>
                              </div>

                              {element.SalesPerson !== "TOT" ?
                                <div className="col-sm-12">

                                  <div className="row">
                                    <div className="col-12 pt-2 pb-3">
                                      <TableofPendingSalesView
                                        Title={"Actual Sales Order Totals"}
                                        Totals={element.Totals.SalesOrder}
                                        data={element.PendingSalesOrders}
                                        loading={element.PendingSalesOrderLoading}
                                        error={element.PendingSalesOrderError}
                                      />
                                    </div>
                                  </div>
                                </div>
                                : <></>}

                              <div className="col-sm-12">

                                <div className="row">
                                  <div className="col-12 pt-2 pb-3">
                                    <TableHistoryCustomerView 
                                      Title={"Days of Last Sale"} 
                                      Totals={element.Totals.Customer} 
                                      data={element.CustomerHistory} 
                                    />
                                  </div>
                                </div>
                              </div>

                            </div>
                          </div>
                        </React.Fragment>
                    }




                  </div>
                </div>
              ))}

              </div>
            </div>

        </div>
      </div>
    )
  }
}